import React from "react";
import { Routes, Route } from "react-router-dom";
import DocsListing from "./docsListing";
import FolderListing from "./folderListing";
import EditDocument from "./editDocument";
const Folders = () => {
  return (
    <Routes>
      <Route path="/" element={<FolderListing />} />
      <Route path="/:id" element={<DocsListing />} />
      <Route path="/:id/form/:form_id/*" element={<EditDocument />} />
    </Routes>
  );
};

export default Folders;
